import PropTypes from 'prop-types';
import React from 'react';
import styles from './LoadingSpinner.css';

class LoadingSpinner extends React.Component {
  render() {
    const { showLoadingSpinner } = this.props;

    // FIXME This should be something handled by parent
    if (!showLoadingSpinner) {
      return null;
    }

    return (
      <div className={styles['loading-container']}>
        <img
          src={require('assets/images/loading-simple.gif')}
          alt="mokapos spinner"
          className="loading-spinner"
        />
      </div>
    );
  }
}

LoadingSpinner.propTypes = {
  showLoadingSpinner: PropTypes.bool,
};

export default LoadingSpinner;
